/* Bazan PDP — Story carousel: drag-to-scroll trên desktop (mouse), touch native trên mobile. */
(function () {
  'use strict';

  function initTrack(track) {
    if (!track || track._bzInit) return;
    track._bzInit = true;

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });

    // Ẩn "SWIPE" indicator sau lần scroll đầu
    var swipe = track.parentNode && track.parentNode.querySelector('.bz-pdp-story__swipe');
    if (swipe) {
      var hide = function () {
        swipe.style.transition = 'opacity 300ms ease';
        swipe.style.opacity = '0';
        track.removeEventListener('scroll', hide);
      };
      track.addEventListener('scroll', hide, { passive: true });
    }

    var section = track.closest('.bz-pdp-story');
    var origCards = Array.prototype.slice.call(track.querySelectorAll('.bz-pdp-story__card'));
    var cards = origCards; // đại diện card gốc (không kể clones)

    // Infinite (360) scroll BIDIRECTIONAL — clone card gốc PREPEND lẫn APPEND.
    // Init scrollLeft = orig[0].offsetLeft (giữa track). Vượt bounds cả 2 chiều -> teleport silent.
    // TẮT scroll-snap-mandatory khi infinite active — snap fight với silent teleport, gây snap-back.
    var origLen = origCards.length;
    if (origLen > 1) {
      // Append clone set (giữ order)
      for (var ci = 0; ci < origLen; ci++) {
        var clnA = origCards[ci].cloneNode(true);
        clnA.setAttribute('aria-hidden', 'true');
        clnA.setAttribute('data-bz-clone', '1');
        track.appendChild(clnA);
      }
      // Prepend clone set (insert reverse để giữ order gốc phía trước origCards[0])
      for (var cj = origLen - 1; cj >= 0; cj--) {
        var clnB = origCards[cj].cloneNode(true);
        clnB.setAttribute('aria-hidden', 'true');
        clnB.setAttribute('data-bz-clone', '1');
        track.insertBefore(clnB, track.firstChild);
      }
      // Tắt snap + smooth behavior — cả 2 gây conflict với silent teleport.
      // (Arrow prev/next vẫn dùng scrollBy({behavior:'smooth'}) explicit, không cần CSS.)
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
    }
    function origWidth() {
      if (!origLen) return 0;
      var f = origCards[0], l = origCards[origLen - 1];
      var gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap;
      var gap = parseFloat(gapStr) || 0;
      return l.offsetLeft + l.offsetWidth - f.offsetLeft + gap;
    }
    function origStart() {
      return origCards[0] ? origCards[0].offsetLeft : 0;
    }
    var teleporting = false;
    function silentSet(pos) {
      teleporting = true;
      var pbBhv = track.style.scrollBehavior;
      var pbSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = pos;
      // Force reflow, sau đó restore để browser không animate về snap point cũ
      void track.offsetWidth;
      track.style.scrollBehavior = pbBhv;
      track.style.scrollSnapType = pbSnap;
      setTimeout(function () { teleporting = false; }, 50);
    }
    // Init scrollLeft: desktop -> origCards[0]; mobile -> middle card centered.
    // Dùng scrollIntoView native (inline: 'center') để browser tự xử clamp + padding.
    // Chờ layout settle + images load để offsetLeft chính xác.
    if (origLen > 1) {
      var isMobile = window.matchMedia('(max-width: 1023px)').matches;
      var defaultIdx = origCards[1] ? 1 : 0;
      function doInit() {
        var s = origStart();
        if (!s) return false;
        var target = origCards[defaultIdx];
        if (isMobile) {
          silentSet(Math.max(0, Math.round(track.scrollLeft + centerDeltaOf(target))));
        } else {
          silentSet(target.offsetLeft);
        }
        return true;
      }
      var initTries = 0;
      var initIv = setInterval(function () {
        initTries++;
        if (doInit() || initTries > 20) clearInterval(initIv);
      }, 50);
      // Re-init sau khi images load (offsetLeft/offsetWidth có thể thay đổi)
      window.addEventListener('load', function () {
        setTimeout(doInit, 100);
      });
    }

    // Arrow prev/next — scroll theo card-width + gap. Với infinite: KHÔNG ẩn arrow.
    var prevBtn = section && section.querySelector('[data-bz-story-prev]');
    var nextBtn = section && section.querySelector('[data-bz-story-next]');
    function stepSize() {
      var first = cards[0];
      if (!first) return track.clientWidth;
      var second = cards[1];
      var gap = second ? (second.offsetLeft - (first.offsetLeft + first.offsetWidth)) : 0;
      return first.offsetWidth + gap;
    }
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      if (origLen > 1) {
        prevBtn.classList.remove('is-hidden');
        nextBtn.classList.remove('is-hidden');
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 0);
      nextBtn.classList.toggle('is-hidden', track.scrollLeft >= maxScroll);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      smoothScrollTo(track, track.scrollLeft - stepSize());
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      smoothScrollTo(track, track.scrollLeft + stepSize());
    });

    // Custom smooth scroll — RAF-based, wrap-aware (adjust start+target khi silentSet
    // teleport scrollLeft giữa animation — nếu không, animation fight với wrap và dừng
    // ở max scroll).
    function smoothScrollTo(el, target) {
      if (el._bzAnim) cancelAnimationFrame(el._bzAnim);
      var duration = 450;
      var startT = null;
      var start = el.scrollLeft;
      var lastLeft = start;
      function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
      function step(ts) {
        if (startT === null) startT = ts;
        var p = Math.min(1, (ts - startT) / duration);
        // Detect wrap teleport: scrollLeft nhảy lớn giữa 2 frame -> adjust baseline
        var jump = el.scrollLeft - lastLeft;
        if (Math.abs(jump) > 100) {
          start += jump;
          target += jump;
        }
        var newLeft = start + (target - start) * ease(p);
        el.scrollLeft = newLeft;
        lastLeft = newLeft;
        if (p < 1) el._bzAnim = requestAnimationFrame(step);
        else el._bzAnim = null;
      }
      el._bzAnim = requestAnimationFrame(step);
    }

    // Dot scroll indicator — dựa trên TẤT CẢ card (orig + clones) để đồng bộ với vị trí user
    // đang thực sự xem. Click dot i -> tìm instance của card i gần center nhất -> smooth scroll.
    var dotsWrap = section && section.querySelector('[data-bz-story-dots]');
    var dots = [];
    function allCardInstances() {
      return Array.prototype.slice.call(track.querySelectorAll('.bz-pdp-story__card'));
    }
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      cards.forEach(function (card, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bz-pdp-story__dot' + (i === 1 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () {
          if (origLen <= 1) {
            card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            return;
          }
          // Wrap-aware SHORTEST delta: đo khoảng cách tới orig[i] rồi chuẩn hoá
          // modulo origWidth để chọn instance gần nhất (không chạy ngược cả vòng).
          var w = origWidth();
          if (!w) return;
          var delta = centerDeltaOf(card);
          delta = ((delta % w) + w) % w;
          if (delta > w / 2) delta -= w;
          if (Math.abs(delta) < 1) return; // đã tại slide đó
          smoothScrollTo(track, track.scrollLeft + delta);
        });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }
    var lastInView = null, lastDotIdx = -1;
    function updateDots() {
      var list = centers();
      if (!list.length) return;
      var absIdx = nearestIndex();
      if (absIdx < 0) return;
      var mod = origLen > 1 ? origLen : list.length;
      var best = absIdx % mod;
      var bestInst = list[absIdx].el;
      // Chỉ ghi class khi thay đổi. Trước đây mỗi frame toggle is-in-view trên
      // cả 15 card và is-active trên mọi dot => style recalc không cần thiết.
      if (bestInst !== lastInView) {
        if (lastInView) lastInView.classList.remove('is-in-view');
        bestInst.classList.add('is-in-view');
        lastInView = bestInst;
      }
      if (dots.length && best !== lastDotIdx) {
        if (dots[lastDotIdx]) dots[lastDotIdx].classList.remove('is-active');
        if (dots[best]) dots[best].classList.add('is-active');
        lastDotIdx = best;
      }
    }
    // ── Mobile (<1024px): 1 slide mỗi cú vuốt ────────────────────────────────
    // Native touch scroll trượt theo momentum qua nhiều card, và CSS snap đã
    // phải tắt vì fight với silent teleport của infinite loop. Nên chặn pan
    // ngang native (touch-action: pan-y) rồi tự xử: kéo theo ngón 1:1, thả ra
    // settle về đúng 1 card kế bên (hoặc về card cũ nếu vuốt chưa tới ngưỡng).
    var mqMobile = window.matchMedia('(max-width: 1023px)');
    function applyTouchMode() {
      track.style.touchAction = mqMobile.matches ? 'pan-y' : '';
    }
    applyTouchMode();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', applyTouchMode);
    else if (mqMobile.addListener) mqMobile.addListener(applyTouchMode);

    // ── Cache tâm card trong hệ toạ độ scroll ────────────────────────────────
    // Đo 1 lần mỗi layout rồi chỉ tính số học. Trước đây mỗi frame quét
    // getBoundingClientRect của toàn bộ 15 card (orig + 2 bộ clone) cho
    // updateDots + nearestCardNow => forced layout liên tục lúc vuốt.
    // KHÔNG dùng offsetLeft: offsetParent là .bz-pdp-story__stage nên lệch so
    // với gốc toạ độ scrollLeft (content box của track) đúng bằng padding-left
    // => card sẽ dừng lệch tâm 20px trên mobile.
    var centerCache = null;
    function measureCenters() {
      var tr = track.getBoundingClientRect();
      var base = tr.left - track.scrollLeft; // gốc toạ độ scroll
      centerCache = [];
      allCardInstances().forEach(function (c) {
        if (!c.offsetWidth) return;
        var r = c.getBoundingClientRect();
        centerCache.push({ el: c, center: r.left + r.width / 2 - base });
      });
      return centerCache;
    }
    function centers() { return centerCache || measureCenters(); }
    function invalidateCenters() { centerCache = null; }
    function viewCenter() { return track.scrollLeft + track.clientWidth / 2; }

    function centerDeltaOf(card) {
      var list = centers(), view = viewCenter();
      for (var i = 0; i < list.length; i++) {
        if (list[i].el === card) return list[i].center - view;
      }
      var tr = track.getBoundingClientRect();
      var cr = card.getBoundingClientRect();
      return (cr.left + cr.width / 2) - (tr.left + tr.width / 2);
    }
    function nearestIndex() {
      var list = centers(), view = viewCenter();
      var best = -1, bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i].center - view);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function nearestCardNow() {
      var i = nearestIndex();
      return i < 0 ? null : centers()[i].el;
    }
    // Settle sau khi thả ngón: easeOutCubic (nhanh ngay lúc thả rồi giảm dần).
    // Dùng ease-in-out như arrow sẽ có đoạn chậm ở đầu, cảm giác như bị giật
    // vì ngón vừa rời khỏi màn hình với vận tốc lớn.
    function snapAnimTo(target) {
      if (track._bzAnim) cancelAnimationFrame(track._bzAnim);
      var duration = 380, startT = null, start = track.scrollLeft, lastLeft = start;
      function ease(t) { var u = 1 - t; return 1 - u * u * u; }
      function frame(ts) {
        if (startT === null) startT = ts;
        var pr = Math.min(1, (ts - startT) / duration);
        var jump = track.scrollLeft - lastLeft;
        if (Math.abs(jump) > 100) { start += jump; target += jump; }
        var next = start + (target - start) * ease(pr);
        track.scrollLeft = next;
        lastLeft = next;
        if (pr < 1) track._bzAnim = requestAnimationFrame(frame);
        else track._bzAnim = null;
      }
      track._bzAnim = requestAnimationFrame(frame);
    }
    // Center `card` rồi dịch thêm `dir` bước. Chọn hướng ngắn nhất modulo cycle
    // để không chạy ngược cả vòng khi card là instance ở xa. `step`/`cycle`
    // truyền từ cache của gesture — không đo lại giữa lúc animate.
    function settleTo(card, dir, step, cycle) {
      if (!card) return;
      var delta = centerDeltaOf(card) + dir * (step || stepSize());
      var w = cycle != null ? cycle : (origLen > 1 ? origWidth() : 0);
      if (w) {
        delta = ((delta % w) + w) % w;
        if (delta > w / 2) delta -= w;
      }
      snapAnimTo(track.scrollLeft + delta);
    }

    if (origLen > 1) {
      var tStartX = 0, tStartY = 0, tLastX = 0, tStartT = 0, tAxis = '', tCard = null;
      var tPendingDX = 0, tRaf = null, tStep = 0, tCycle = 0;

      // Gộp mọi touchmove trong 1 frame thành ĐÚNG 1 lần ghi scrollLeft.
      // Ngón thật bắn ~2-3 touchmove/frame; ghi scrollLeft mỗi lần sẽ kéo theo
      // 2-3 scroll event/frame -> wrap check + updateDots đọc rect 15 card =>
      // forced layout nhiều lần trong 1 frame, đó là chỗ giật.
      function flushDrag() {
        tRaf = null;
        if (!tPendingDX) return;
        track.scrollLeft -= tPendingDX;
        tPendingDX = 0;
      }

      track.addEventListener('touchstart', function (e) {
        if (!mqMobile.matches || !e.touches || e.touches.length !== 1) return;
        if (track._bzAnim) { cancelAnimationFrame(track._bzAnim); track._bzAnim = null; }
        tStartX = tLastX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tStartT = Date.now();
        tAxis = '';
        tPendingDX = 0;
        tCard = nearestCardNow();
        // Đo 1 lần cho cả gesture — layout không đổi giữa lúc vuốt.
        ensureGeo();
        tStep = stepSize();
        tCycle = geoW;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!mqMobile.matches || !e.touches || e.touches.length !== 1) return;
        var x = e.touches[0].clientX, y = e.touches[0].clientY;
        if (!tAxis) {
          var adx = Math.abs(x - tStartX), ady = Math.abs(y - tStartY);
          if (adx < 6 && ady < 6) return;
          tAxis = adx > ady ? 'x' : 'y';
        }
        if (tAxis !== 'x') return; // vuốt dọc -> để page scroll bình thường
        e.preventDefault();
        // Cộng dồn delta, KHÔNG tính lại từ tStartX: wrap teleport đổi
        // scrollLeft giữa gesture, tính lại từ start sẽ ghi đè teleport đó.
        tPendingDX += (x - tLastX);
        tLastX = x;
        if (!tRaf) tRaf = requestAnimationFrame(flushDrag);
      }, { passive: false });

      track.addEventListener('touchend', function () {
        if (!mqMobile.matches || tAxis !== 'x') { tAxis = ''; return; }
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        flushDrag();
        var dist = tLastX - tStartX;
        var dt = Math.max(1, Date.now() - tStartT);
        var dir = 0;
        // Qua ngưỡng khoảng cách HOẶC vuốt nhanh (flick) -> đi đúng 1 card.
        if (Math.abs(dist) > 40 || Math.abs(dist) / dt > 0.4) dir = dist < 0 ? 1 : -1;
        settleTo(tCard, dir, tStep, tCycle);
        tAxis = '';
      });

      track.addEventListener('touchcancel', function () {
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        if (tAxis === 'x') settleTo(tCard, 0, tStep, tCycle);
        tAxis = '';
      });
    }

    // Cache hình học vòng loop: chỉ phụ thuộc layout, không phụ thuộc scroll.
    // origWidth() gọi getComputedStyle + đọc offsetLeft, mà scroll handler chạy
    // hàng chục lần mỗi gesture -> cache và chỉ tính lại khi layout đổi.
    var geoW = 0, geoS = 0, geoDirty = true;
    function invalidateGeo() { geoDirty = true; invalidateCenters(); }
    function ensureGeo() {
      if (!geoDirty) return;
      geoW = origWidth();
      geoS = origStart();
      geoDirty = false;
    }
    window.addEventListener('load', invalidateGeo);
    // Ảnh card load xong -> layout đổi -> đo lại tâm card.
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', invalidateGeo);
    });

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      // Bidirectional wrap — vượt bounds 2 chiều -> teleport về vùng gốc.
      if (origLen > 1 && !teleporting) {
        ensureGeo();
        if (geoW) {
          if (track.scrollLeft >= geoS + geoW) silentSet(track.scrollLeft - geoW);
          else if (track.scrollLeft < geoS) silentSet(track.scrollLeft + geoW);
        }
      }
      // 1 rAF đang chờ là đủ — nhiều scroll event trong cùng frame trước đây
      // xếp nhiều callback, mỗi callback đọc rect của toàn bộ card.
      if (!scrollRaf) {
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = null;
          updateDots();
          updateArrows();
        });
      }
    }, { passive: true });
    window.addEventListener('resize', function () {
      invalidateGeo();
      updateDots();
      updateArrows();
    });
    updateDots();
    updateArrows();
  }

  function boot() {
    document.querySelectorAll('[data-bz-story-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target && e.target.querySelector('[data-bz-story-track]');
    if (t) initTrack(t);
  });
})();

// v=1788772764

// v=1788777189

// v=1788960108

// v=1788960277

// v=1788961927

// v=1788963092
